<template>
  <div>
    <div>{{ selectedAttachmentType }}</div>
    <slot></slot>
  </div>
</template>

<script lang="ts">
  import Vue from "vue";
  import propertyBaseMixin from "../mixins/property-base-mixin";
  import {FileAttachmentType} from "~/enums/fileAttachmentType";

  export default Vue.extend({
    mixins: [propertyBaseMixin],
    data: function () {
      return {};
    },
    computed: {
      selectedAttachmentType(): string {
        const selected: string = FileAttachmentType[this.objectModelProperty.file_attachment_type];
        return selected === "MultipleFiles" ? "Multiple Files" : "Single File";
      }
    }
  });
</script>
